export default {
    AppHeader: {
        language: 'Traduction',
        languageTooltip: 'Sélectionnez une langue',
        languageSwitchedMessage: 'La langue est passée à {0} avec succès.'
    }
};
